import { definePinoWebTransport } from '../../definePinoWebTransport';
import { consoleTransportHandler } from './consoleTransportHandler';
export const consoleWebTransport = definePinoWebTransport(consoleTransportHandler);
//# sourceMappingURL=consoleWebTransport.js.map